import { Box, Skeleton, Stack, Typography } from '@mui/material'
import BulkPaymentStepper from '../components/BulkPaymentStepper/BulkPaymentStepper'
import PageHeader from '../components/PageHeader'
import { BulkPaymentStepperContextProvider, useBulkPaymentStepperContext } from '../contexts/BulkPaymentStepperContext'
import { useDocumentTitle } from '../hooks/useDocumentTitle'

function BulkPaymentEntryPageInner() {
  useDocumentTitle('Bulk Payment Entry')
  const { fetching } = useBulkPaymentStepperContext()

  return (
    <Box>
      <PageHeader title="Bulk Payment Entry" />
      {fetching ? (
        <Stack spacing={2} maxWidth="sm" mt={2}>
          <Skeleton variant="rectangular" sx={{ height: '4em' }} />
          <Stack direction="row" spacing={2} height="4em">
            <Skeleton sx={{ flex: 1 }} />
            <Skeleton sx={{ flex: 1 }} />
            <Skeleton sx={{ flex: 1 }} />
          </Stack>
        </Stack>
      ) : (
        <Stack maxWidth="md" mt={2}>
          <Typography variant="body2" mb={4}>
            Use this page to enter payments against multiple POs at once.
          </Typography>
          <BulkPaymentStepper />
        </Stack>
      )}
    </Box>
  )
}

export default function BulkPaymentEntryPage() {
  return (
    <BulkPaymentStepperContextProvider>
      <BulkPaymentEntryPageInner />
    </BulkPaymentStepperContextProvider>
  )
}
